import React, { useReducer, useState } from "react";

import { Slide } from './Slider/Slide';
import NextPrev from './Slider/Buttons';

import Oko from '../files/oko.png';
import Github from '../files/github.png'
import Mockup1 from '../files/mockup1.jpg'
import Mockup2 from '../files/mockup2.jpg'
import sql from '../files/sql.jpg'
import node from '../files/node.png'
import Duma from '../files/duma.jpg'

import {
  Cutout,
  Button
} from 'react95';



export const Slider = (props) => {
  const [state, dispatch] = useReducer(reducer, {
    currentIndex: 0,
    items: [
      { id: 1, text: "Website `Podróżuj z Dumą` is the biggest project I have done. It is an advanced CRUD of a holiday tour company. Thanks to this project I was able to develop my programming skills in node.js and learn a lot about hosting and SEO. ", src: `${Duma}`, tech: "React   Hooks   Express   Auth0   Nodemailer    Styled Components", preview: "https://podrozujzduma.pl/", github:null },
      { id: 2, text: "Photo blog based on Imgur API and Auth0.", src: `${Mockup1}`, tech: "React    Hooks     Imgur API      Auth0     EmailJS", preview: "https://lukaszbiernat.netlify.app/", github: "https://github.com/Paranoidal97/Imgur-react-photoblog" },
      { id: 3, text: "The virtual breathalyzer was created on the basis of an algorithm found in one of the newspapers. Unfortunately, the algorithm is not accurate but it was an excellent exercise to improve my skills.", src: `${Mockup2}`, tech: "React    Hooks   Bootstrap", preview: "https://paranoidal97.github.io/Virtual-Breathalyzer/", github: "https://github.com/Paranoidal97/Virtual-Breathalyzer"  },
      { id: 4, text: "Project for a college course on relational databases in Oracle dialect. The task was to create an ERD diagram, create a database based on it and then perform a specific type of query on it.", src: `${sql}`, preview: null, tech: "Vertabelo    PL/SQL" ,github: "https://github.com/Paranoidal97/RBD-PJWSTK-projekt-erd-sql" },
      { id: 5, text: "My first CRUD application using React as frontend and Node.js-Express server as backend with MySQL as database service.", tech:"React     Node    express.js     MySql", github:"https://github.com/Paranoidal97/CRUD-MYSQL-NODE-REACT", preview:null ,src: `${node}` },
      { id: 6, text: "Coming soon", preview: null, github: null, src: "https://cdn3.f-cdn.com/files/download/40993717/l5h1cuegae.jpg" }
    ]
  });

  return (

    <div className="container-fluid p-0">
      {state.items.map((i, index) => {
        return (
          <Slide
            key={i.id}
            last={index === state.items.length - 1}
            index={index}
            item={i}
            dispatch={dispatch}
            snap={state.snap}
            currentIndex={state.currentIndex}
          />
        );
      })}

      <div className="row no-gutters" style={{ paddingTop: "15px", paddingBottom: "15px" }}>
        <Cutout className="col-12" />
      </div>
      <div className="row">
        <div className={props.portair ? "col-12 d-flex my-2 justify-content-center" : "col-md-6 d-flex justify-content-start my-1"}>
        {
            state.items[state.currentIndex].preview === null ? null : 

            <Button size='lg' style={{ minWidth: "90px" }} className="mx-2"  target="_blank"
          onClick={(e) => {
            e.preventDefault();
            window.open(`${state.items[state.currentIndex].preview}`, "_blank");
                      }}>
            <img src={Oko} style={{ maxHeight: "80%", padding: "3px", maxWidth: "80%", padding: "3px", display: "block" }} alt="sad" />
          </Button>

          } 
          {
            state.items[state.currentIndex].github === null ? null : 

            <Button size='lg' style={{ minWidth: "90px" }} className="mx-2" 
            onClick={(e) => {
              e.preventDefault();
              window.open(`${state.items[state.currentIndex].github}`, "_blank");
            }}>
              <img src={Github} style={{ maxHeight: "80%", padding: "3px", maxWidth: "80%", padding: "3px", display: "block" }} alt="ad" />
            </Button>

          }
         
        </div>
        <div className={props.portair ? "col-12 d-flex justify-content-center" : "col-md-6 d-flex justify-content-end"}>
          <NextPrev items={state.items.length} currentIndex={state.currentIndex} nextAction={() => dispatch({ type: "NEXT" })} prevAction={() => dispatch({ type: "PREV" })} />
        </div>
      </div>
    </div>
  );
};

function reducer(state, action) {
  switch (action.type) {
    case "NEXT":
      return {
        ...state,
        currentIndex: state.currentIndex + 1
      };
    case "PREV":
      return {
        ...state,
        currentIndex: state.currentIndex - 1
      };
    case "RESET":
      return { currentIndex: 0, currentPosition: 0 };

    default:
      return state;
  }
}









